import { v4 as uuid } from 'uuid';
import { useMemo } from 'react';

export const useUniqId = (name?: string): string => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => uuid(), [name]);
};
